module.exports = __webpack_public_path__ + "img/islington_side_ext_b2.e39e81f1.jpg";